export default Object.freeze({
  CREATED: 1,
  PROCESSING: 2,
  APPROVED: 3,
  REJECTED: 4,
});

